export default function stoteCardDetail(state = { cardNumber: "" }, action) {
    switch (action.type) {
        case 'STORE_CARD':
            return {
                cardNumber: action.cardNumber
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/storecarddetail.jsx